<template>
    <div :class="cardGroupClass">
        <LayerFeatureableGroupItem
            v-for="(feature, index) in features"
            :key="`layer-featureable-feature-${index}`"
            :value="feature"
            :title="entityName"
            :featureableConfig="featureableConfig"
            :translateID="translateID"
            @selected="onSelected"
        />
    </div>
</template>

<script>
    export default {
        mixins: [
        ],
        components:{
            LayerFeatureableGroupItem: () => import(/* webpackChunkName: "recursive-details-layer-featureablegroup-item" */ './LayerFeatureableGroupItem'),
        },
        props: {
            cardGroupClass: {
                type: String,
                default: 'card-columns',
            },
            translateID: {
                type: String,
                default: 'featureable',
            },
            entity: {
                type: Object,
                default: () => {
                    return {}
                },
            },
            items: {
                type: [Object, Array],
                default: () => {
                    return []
                },
            },
        },
        data() {
            return {
            }
        },
        computed: {
            entityName() {
                return this.entity?.name;
            },
            featureableConfig() {
                return this.entity?.featureable ?? {};
            },
            crs() {
                return this.items?.featureCollection?.crs ?? {};
            },
            features() {
                return this.items?.featureCollection?.features ?? []
            }
        },
        methods: {
            onSelected(params) {
                this.$emit('selected', JSON.parse(JSON.stringify({
                    entity: {
                        id: this.entity?.id,
                        name: this.entity?.name,
                        image: this.entity?.image,
                    },
                    config: this.featureableConfig,
                    crs: this.crs,
                    ...params,
                })));
            }
        },
    }
</script>